module.exports = __webpack_public_path__ + "img/WNW.993be372.svg";